const IMG = 'https://cloud.sharemyimage.com/2026/10/21/';

export const ROOMS_TABLE = 'site_rooms_1700000000001';
export const ROOM_PHOTOS_TABLE = 'site_room_photos_1700000000001';

const bedrooms = (slug) => [
  { id: `d-${slug}-1`, room_slug: slug, url: `${IMG}Bedroom-image-1.png`, caption: 'Bedroom', media_type: 'image', sort_order: 1 },
  { id: `d-${slug}-2`, room_slug: slug, url: `${IMG}Bedroom-image-2.png`, caption: 'Bedroom', media_type: 'image', sort_order: 2 }
];

export const ROOM_DEFAULTS = [
  {
    slug: 'kotiya', name: 'Kotiya', sort_order: 1, cover_url: `${IMG}Kotiya.png`,
    tagline: 'Named for the leopard. A calm, considered retreat for couples and solo travellers.',
    description: 'Kotiya is named for the leopard of Yala. Wake to soft light, a comfortable king bed and the quiet sounds of the garden. It is a calm, considered space for couples and solo travellers who want to rest well between safari adventures.',
    features: 'King bed, Garden view, Private veranda, Air conditioning',
    max_guests: 2,
    add_ons: 'We can provide 2 extra single beds for each room.',
    photos: bedrooms('kotiya')
  },
  {
    slug: 'walaha', name: 'Walaha', sort_order: 2, cover_url: `${IMG}Walaha.png`,
    tagline: 'Named for the sloth bear. Room to slow down, with comfort for the whole family.',
    description: 'Walaha is named for the shy sloth bear. A generous, comfortable room with space to spread out, perfect for families or friends travelling together who want a restful base close to Yala National Park.',
    features: 'Spacious layout, Lounge space, Garden access, Air conditioning',
    max_guests: 2,
    add_ons: 'We can provide 2 extra single beds for each room.',
    photos: bedrooms('walaha')
  },
  {
    slug: 'aliya', name: 'Aliya', sort_order: 3, cover_url: `${IMG}Aliya-Room.png`,
    tagline: 'Named for the elephant. A little more privacy, wrapped in the quiet of the tropics.',
    description: 'Aliya is named for the gentle giants of Yala. A peaceful, private room wrapped in greenery, designed for guests who want a little extra stillness, with all the comforts you need after an early morning safari.',
    features: 'King bed, Private terrace, Garden view, Air conditioning',
    max_guests: 2,
    add_ons: 'We can provide 2 extra single beds for each room.',
    photos: bedrooms('aliya')
  }
];